import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { AgentDetail } from '../../../types/agent-studio';

export interface ConfigurationTabProps {
  agent: AgentDetail;
}

function ConfigSection({ title, content, contentType }: {
  title: string;
  content: string;
  contentType: 'text' | 'json';
}) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API can fail in some browsers; degrade silently
    }
  }

  return (
    <div className="card" style={{ marginBottom: '16px', padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', marginBottom: '12px' }}>
        <div className="t-eyebrow">{title}</div>
        <button
          onClick={handleCopy}
          style={{
            background: 'transparent',
            border: '1px solid var(--border-subtle, rgba(0,0,0,0.12))',
            padding: '4px 12px',
            fontSize: '12px',
            cursor: 'pointer',
            borderRadius: '4px',
            color: 'var(--ink-secondary)',
          }}
        >
          {copied ? 'Скопировано ✓' : 'Скопировать'}
        </button>
      </div>
      <pre style={{
        background: 'var(--bg-subtle, rgba(0,0,0,0.03))',
        padding: '16px',
        borderRadius: '4px',
        fontFamily: "'Menlo', 'Consolas', 'Courier New', monospace",
        fontSize: '13px',
        lineHeight: 1.6,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        maxHeight: '400px',
        overflow: 'auto',
        margin: 0,
        color: contentType === 'json' ? 'var(--navy)' : 'var(--ink-primary)',
      }}>
        {content || '—'}
      </pre>
    </div>
  );
}

export function ConfigurationTab({ agent }: ConfigurationTabProps) {
  const navigate = useNavigate();
  const v = agent.active_version;

  if (!v) {
    return (
      <div className="card" style={{ padding: '32px', textAlign: 'center' }}>
        <p className="t-body" style={{ color: 'var(--ink-secondary)' }}>
          У этого агента нет активной версии.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', marginBottom: '16px' }}>
        <div className="t-eyebrow" style={{ color: 'var(--ink-secondary)' }}>
          КОНФИГУРАЦИЯ ВЕРСИИ v{v.version_number}
        </div>
        <button
          onClick={() => navigate(`/agents/${agent.system_name}/edit`)}
          style={{
            padding: '8px 16px',
            background: 'var(--navy)',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: 600,
          }}
        >
          Создать новую версию
        </button>
      </div>

      <ConfigSection
        title="Системные инструкции"
        content={v.system_instructions}
        contentType="text"
      />
      <ConfigSection
        title="Шаблон промпта"
        content={v.prompt_template}
        contentType="text"
      />
      <ConfigSection
        title="Дополнительные параметры"
        content={JSON.stringify(v.extra_config, null, 2)}
        contentType="json"
      />
    </div>
  );
}
